export default __webpack_public_path__ + "static/media/vietnam.58a5fa6e.svg";